<template>
<section class="contact">
  <div class="container">
    <div class="contact_form">
      <form action="">
        <div class="form_group">
          <label for="name">Name:</label>
          <input
              id="name"
              class="styled_input"
              type="text"
              placeholder="Your name"
              autocomplete="name"
              v-model="name"
          >
        </div>
        <div class="form_group">
          <label for="email">Email:</label>
          <input
              id="email"
              class="styled_input"
              type="email"
              placeholder="Your e-mail"
              autocomplete="email"
              v-model="email"
          >
        </div>
        <div class="form_group">
          <label for="message">Message:</label>
          <div class="message_container">
            <textarea
                id="message"
                class="styled_input"
                placeholder="Your message"
                v-model="body">
            </textarea>
          </div>
        </div>
        <Button @click.native="showUnavaiable">Send</Button>
      </form>
    </div>
  </div>
</section>
</template>

<script>
import Button from '../Button';

export default {
  name: 'Contact',
  components: {
    Button,
  },
  data() {
    return {
      name: '',
      email: '',
      body: '',
    };
  },
  methods: {
    showUnavaiable() {
      this.$store.commit('openAlert', {
        title: 'Information',
        body: 'This feature is not avaiable right now, you can still contact me at pinnarodriguez97@gmail.com',
      });
      this.name = '';
      this.email = '';
      this.body = '';
    },
  },
};
</script>

<style lang="scss">
.contact {
  padding: 10px 0 40px;
  .container {
    .contact_form {
      max-width: 500px;
      width: 100%;
      margin: 0 auto;
      .form_group {
        padding-bottom: 20px;
        label {
          display: inline-block;
          color: $text_gray;
          padding-bottom: 5px;
        }
        .styled_input {
          width: 100%;
          border: 1px solid #4E4E4E;
          background: $text_gray;
          padding: 10px;
          transition: all .2s ease;
          border-radius: 2px;
          position: relative;
          &:focus {
            box-shadow: 0 3px 6px rgba(#000, .35);
            background: lighten($text_gray, 10);
          }
        }
        .message_container {
          textarea {
            resize: none;
            width: 100%;
            height: 85px;
            max-height: 85px;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 575px) {
  .contact {
    .container {
      .contact_form {
        margin: 0;
        max-width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Contact/Contact.vue